export enum SteamSheetItemType {
  HYDROCARBON = 'hydrocarbon',
  UTILITIES_TITLE = 'utilities-title',
  TOTAL = 'total',
}
